import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2506a74a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "subject-platform"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "platform-header"
}, " 国家站 ", -1));
const _hoisted_3 = {
  class: "platform-content"
};
const _hoisted_4 = {
  class: "item-img"
};
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = {
  class: "item-title"
};
const _hoisted_7 = {
  class: "item-btn"
};
const _hoisted_8 = ["href"];
const _hoisted_9 = ["href"];
const _hoisted_10 = ["href"];
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "platfomr-none"
}, "暂无信息", -1));
const _hoisted_13 = [_hoisted_12];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$subjectMutiplatD, _ctx$subjectMutiplatD2;
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_ctx$subjectMutiplatD = _ctx.subjectMutiplatData) !== null && _ctx$subjectMutiplatD !== void 0 && _ctx$subjectMutiplatD.items.length ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx$subjectMutiplatD2 = _ctx.subjectMutiplatData) === null || _ctx$subjectMutiplatD2 === void 0 ? void 0 : _ctx$subjectMutiplatD2.items, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.title,
      class: "platform-item"
    }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
      src: item.image,
      alt: item.title
    }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_7, [item.front ? (_openBlock(), _createElementBlock("a", {
      key: 0,
      href: item.front,
      target: "_blank"
    }, " 买家前台 ", 8, _hoisted_8)) : _createCommentVNode("", true), item.back ? (_openBlock(), _createElementBlock("a", {
      key: 1,
      href: item.back,
      target: "_blank"
    }, " 卖家后台 ", 8, _hoisted_9)) : _createCommentVNode("", true), !item.front && !item.back && item.click ? (_openBlock(), _createElementBlock("a", {
      key: 2,
      href: item.click,
      target: "_blank"
    }, " 点击进入 ", 8, _hoisted_10)) : _createCommentVNode("", true)])]);
  }), 128))])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))]);
}